import React, { useMemo } from 'react';
import { Input, TextArea } from 'tea-component';
import { useIntl } from 'umi';
import { RowColType } from '../constants';

/**
 * 添加行列表单配置 Hook
 * 根据行/列类型返回不同的表单配置
 */
export const useSmartFillFormConfig = (type: RowColType) => {
  const { formatMessage } = useIntl();
  
  const config = useMemo(() => {
    // 列表单配置：包含列名称和 Prompt
    const columnConfig = [
      {
        name: 'column_name',
        label: formatMessage({ id: 'dba_smart_table_column_name' }),
        component: <Input size="full" placeholder={formatMessage({ id: 'dba_smart_table_column_name_placeholder' })} />,
        rules: { 
          message: formatMessage({ id: 'dba_smart_table_column_name_required' }), 
          required: true,
        },
      },
      {
        name: 'prompt',
        label: 'Prompt',
        className: 'dba-smart-fill-form__prompt-field',
        component: (
          <TextArea 
            className="dba-smart-fill-form__prompt-textarea"
            placeholder={formatMessage({ id: 'dba_smart_table_column_prompt_placeholder' })} 
            size="full"
            rows={4}
          />
        ),
        rules: { 
          message: formatMessage({ id: 'dba_smart_table_prompt_required' }), 
          required: true,
        },
      },
    ];

    // 行表单配置：仅包含 Prompt
    const rowConfig = [
      {
        name: 'prompt',
        label: 'Prompt',
        className: 'dba-smart-fill-form__prompt-field',
        component: (
          <TextArea 
            className="dba-smart-fill-form__prompt-textarea"
            placeholder={formatMessage({ id: 'dba_smart_table_row_prompt_placeholder' })} 
            size="full"
            rows={4}
          />
        ),
        rules: { 
          message: formatMessage({ id: 'dba_smart_table_prompt_required' }), 
          required: true,
        },
      },
    ];

    return type === RowColType.COLUMN ? columnConfig : rowConfig;
  }, [type, formatMessage]);

  return { config };
};
